import { useEffect, useState } from "react";

/**
 * カウントを行うカスタム フック。
 * @param {number} delay - カウントを実行する頻度 (ミリ秒)。
 * @param {boolean} start - 即座にカウントを開始するか否か。
 * @returns カウント、delay を設定する関数、カウントの開始・停止を設定する関数を含んだ Object。
 */
export const useCounter = (
  delay: number,
  start = true
) => {
  /** カウント。 */
  const [count, setCount] = useState<number>(0);

  /** カウントを実行する頻度 (ミリ秒)。 */
  const [delayState, setDelay] = useState<number>(delay);

  /** カウントを実行するか否か。 */
  const [doCount, setDoCount] = useState<boolean>(start);

  // setInterval() によるカウントを実行する。
  useEffect(
    () => {
      let intervalId: NodeJS.Timer | undefined;

      // カウントを停止する関数。
      const stopCount = () => {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = undefined;
        }
        setCount(0);
      };

      if (doCount) {
        intervalId = setInterval(
          () => {
            // console.log('count!!');

            setCount((previousCount: number) => previousCount + 1);
          },
          delayState
        );
      }
      else {
        stopCount();
      }

      // クリーンアップ。
      return stopCount;
    },
    [delayState, doCount]
  );

  return (
    {
      count,
      setDelay,
      setDoCount,
    }
  );
};